/** @module csi/view/customview/DeleteController */
define([
	"dojo/_base/declare",
	"dojo/when",
	"csi",
	"csi/action/Controller",
	"csi/locale",
	"csi/prefs",
	"./_DefaultControllerMixin"
], function(declare, when, csi, Controller, locale, csiPrefs, _DefaultControllerMixin) {

	return declare([Controller, _DefaultControllerMixin], {
		/** @property {string[]} _deletedCustomViewUrls - urls to delete */
		_deletedCustomViewUrls: null,

		/**
		 * @override
		 * Reuse confirmation message for normal delete action
		 */
		confirmAction: function() {
			this._confirmDeleteCustomView(this.widget.getSelectedCustomView());
		},

		/**
		 * @override
		 * Delete selected custom view and its dependents
		 */
		onConfirmDeleteCustomView: function(confirmed, selectedUrl, dependentUrls) {
			if (confirmed) {
				const urls = this._deletedCustomViewUrls = dependentUrls.concat(selectedUrl);
				urls.forEach(this._deleteCustomView, this);
				this.process();
			} else {
				this.postProcess();
			}
		},

		/**
		 * @override
		 * Refresh view with next best default
		 */
		postProcessSuccess: function() {
			const defaults = csiPrefs.getDefaults();
			const view = this.widget;

			// remove the view from defaults
			this._deletedCustomViewUrls.forEach(defaults.remove, defaults);

			// remove the view from store
			this._applyCustomViewChangesToStore();

			// set the default view and refresh
			view.set("customViewDirty", false);
			view.refreshDefaultCustomView();
		}
	});
});